module.exports = __webpack_public_path__ + "static/media/5@3x.b35191d2.png";